import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { Project } from '../../../model/editor/Project';
import { EditorProjectService } from '../../service-data/editor/editor-project.service';
import {Router} from "@angular/router";
import {StartupService} from "../../service-ui/startup.service";
import {Chapter} from "../../../model/editor/Chapter";
import {ConfirmDialogComponent} from "../confirm-dialog/confirm-dialog.component";
import {LanguagePipe} from "../../pipe/language.pipe";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-chapter-nav-tile',
  templateUrl: './chapter-nav-tile.component.html',
  styleUrls: ['./chapter-nav-tile.component.css']
})
export class ChapterNavTileComponent implements OnInit {
  @ViewChild('placeHolderChapterName') placeHolderChapterName;
  @Input() project: Project;
  @Input() chapter: Chapter;
  @Input() selectedChapter: Chapter;

  public renameChapter: boolean = false;

  constructor(public router: Router, public startupService: StartupService, private projectService: EditorProjectService, public dialog: MatDialog) {
  }

  ngOnInit() {
  }


  deleteChapter(chapter: Chapter): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: {
        title: LanguagePipe.get('Delete Chapter', 'compressSpaces') + ' ' + chapter.title + LanguagePipe.get('?', 'compressSpaces'),
        body: '', // LanguagePipe.get('Delete', 'compressSpaces') + ' ' + project.name + LanguagePipe.get('?', 'compressSpaces'),
        noButton: LanguagePipe.get('Cancel', 'compressSpaces'),
        yesButton: LanguagePipe.get('Delete Chapter', 'compressSpaces'),
        returnValue: 'ok'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed. result[' + result + ']');
      if ( result && result === 'ok' ) {
        const index = this.project.interior.chapters.indexOf(chapter);
        if ( index > -1 ) {
          this.project.interior.chapters.splice(index, 1);
          this.projectService.saveProjectAndCanvas(this.startupService.canvasManager, this.startupService.project, this.startupService.canvasManager.canvas);
        }
      }
    });

  }

  isChapterNameUsed(): boolean {
    if ( !this.placeHolderChapterName || !this.placeHolderChapterName.nativeElement || !this.placeHolderChapterName.nativeElement.value ) {
      return true;
    }
    const newTitleName = this.placeHolderChapterName.nativeElement.value.trim();
    for ( const chapter of this.project.interior.chapters ) {
      if ( newTitleName === chapter.title ) {
        return true;
      }
    }
    return false;
  }

  moveChapter(chapter: Chapter, amount: number) {
    const index = this.project.interior.chapters.indexOf(chapter);
    if ( index > -1 ) {
      this.project.interior.chapters.splice(index, 1);
      this.project.interior.chapters.splice(index + amount, 0, chapter);
      // this.projectService.saveProjectImmediately(this.project).then( proj => {
      //   console.log('Reordered chapters');
      // });
      this.projectService.saveProjectAndCanvas(this.startupService.canvasManager, this.startupService.project, this.startupService.canvasManager.canvas);
    }
  }
  chapterIndex(): number {
    return this.project.interior.chapters.indexOf(this.chapter);
  }
  saveChapterValue() {
    this.chapter.title = this.placeHolderChapterName.nativeElement.value;
    this.projectService.saveProjectAndCanvas(this.startupService.canvasManager, this.startupService.project, this.startupService.canvasManager.canvas);
    // this.projectService.saveProjectImmediately(this.project).then( proj => {
    //   console.log('Updated project');
    // });
  }
  /**
   * Discard an in-progress chapter rename.
   *
   * The template has always called `cancelChapterValue()`; only
   * `cancelProjectValue()` existed -- copy-pasted from the project rename
   * components, where it resets the textarea to `project.name`. That is the
   * wrong field for a CHAPTER rename, and it was dead code here regardless,
   * because nothing in this template referenced it.
   *
   * The visible symptom was mild, which is why it survived: the Cancel span
   * runs `renameChapter = !renameChapter` FIRST, so the editor had already
   * closed by the time the missing call threw, and the throw only aborted the
   * remainder of the handler. It still threw on every cancel click.
   *
   * Restoring the title is belt-and-braces -- `*ngIf="renameChapter"` destroys
   * the textarea and it is rebuilt from `[ngModel]="chapter.title"` next time
   * -- but it keeps the control correct if that binding is ever changed to a
   * two-way one, and it costs nothing.
   */
  cancelChapterValue() {
    if ( this.placeHolderChapterName && this.placeHolderChapterName.nativeElement && this.chapter ) {
      this.placeHolderChapterName.nativeElement.value = this.chapter.title;
    }
  }
}

